import styled from 'styled-components';
import { Section } from '@keaze/web/components';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

export const PageSection = styled(Section)`
  ${({ theme: { breakpoints } }) => `
    padding: 60px 0 100px;
    margin: 0 0 50px;
    ${breakpoints.down('xs')} {
      padding: 30px 0;
      margin: 0 0 30px;
    }
  `}
`;

export const PageContent = styled.div`
  ${({ theme: { colors } }) => `
      color: ${colors.greens.green0} !important; `}
  max-width: 960px;
  margin: auto;
`;

export const PageTitle: any = styled(Typography)`
  ${({ theme: { breakpoints, colors } }) => `
      color: ${colors.greens.green0} !important;
      font-size: 24px;
      font-weight: 500;
      margin: 0 0 1em;
    ${breakpoints.down('md')} {
      font-size: 27px;
    }
  `}
`;

export const Paragraph = styled.div`
  ${({ theme: { breakpoints, colors } }) => `
      & + & {
        margin-top: 1.2em;
      }
      p + p {
        margin-top: 1.2em;

      }

      font-size: 16px;
      font-weight: 400;
    ${breakpoints.down('md')} {
      font-size: 18px;
    }
  `}
`;

export const PrivacyIButton = styled(Button)`
  ${({ theme: { breakpoints, colors } }) => `


border: 1px solid ${colors.greens.green0}};
color: ${colors.greens.green0};

padding: 10px 20px;

box-shadow: -1px 1px 6px ${colors.greens.green0};
`}
`;
